import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import './QRPosterCard.css';

const THEMES = ['theme-green', 'theme-amber', 'theme-blue'];

const QRPosterCard = ({ section, storeName, qrValue, index, onDownload }) => {
  const theme = THEMES[index % THEMES.length];
  const sectionName = section?.sectionName || section?.name || 'Section';

  return (
    <div className={`qr-poster-card ${theme}`}>
      <div className="qr-poster-card__preview">
        <span className="qr-poster-card__kicker">{storeName || 'Your Store'}</span>
        <div className="qr-poster-card__qr-box">
          <QRCodeCanvas
            value={qrValue || 'Zopeo'}
            size={112}
            level="H"
            includeMargin={false}
            fgColor="#080808"
            bgColor="#ffffff"
          />
        </div>
        <span className="qr-poster-card__title">{sectionName}</span>
        <span className="qr-poster-card__subtitle">Scan to join queue</span>
      </div>
      <div className="qr-poster-card__footer">
        <span className="qr-poster-card__footer-label">{sectionName}</span>
        <div className="qr-poster-card__footer-actions">
          <button
            type="button"
            className="qr-poster-card__action-btn"
            onClick={() => onDownload?.(section)}
          >
            PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default QRPosterCard;
